$.fn.dragTable = function () {
    const el = $(this);
    el.css('overflow-x', 'auto');

    const datagridWidth = el.width();
    const tableWidth = el.find('table').width();

    if (!el.parent().find('.gradient').length) {
        el.parent().append('<div class="gradient"></div>');
        el.parent().find('.gradient').css('bottom', el.height() - el.find('form').height());
    }

    let boxShadowValue = '';
    let boxShadowX = 0;
    while (boxShadowX < datagridWidth * 0.2) {
        boxShadowValue += `${-boxShadowX}px 0 ${boxShadowX}px -4px rgba(255,255,255,${(1 - (boxShadowX / (datagridWidth * 0.5))) * 0.3}),`;
        boxShadowX += 10;
    }
    boxShadowX = 0;
    while (boxShadowX < datagridWidth / 10) {
        boxShadowValue += `${-boxShadowX}px -15px  20px -4px white,`;
        boxShadowX += 10;
    }
    boxShadowValue += '-2px 0 5px -4px white, -2px 0 5px -4px white, -2px 0 5px -4px white';


    el.parent().find('.gradient').css('box-shadow', boxShadowValue);


    if (datagridWidth < tableWidth) {
        el.parent().addClass('gradient-show');
    } else {
        el.parent().removeClass('gradient-show');
    }

    let attachment = false;
    let lastPosition;
    let position;
    let difference;
    el.on('mousedown mouseup mousemove', (e) => {
        if (e.type === 'mousedown') {
            attachment = true;
            lastPosition = e.clientX;
            $(el).addClass('noselect');
        }
        if (e.type === 'mouseup') {
            attachment = false;
            $(el).removeClass('noselect');
        }
        if (e.type === 'mousemove' && attachment === true) {
            position = e.clientX;
            difference = position - lastPosition;
            el.scrollLeft(el.scrollLeft() - difference);
            lastPosition = e.clientX;
        }
    });
    $(window).on('mouseup', () => {
        attachment = false;
        $('.datagrid .table').removeClass('noselect');
    });

    el.scroll(() => {
        maxScroll = el.find('.table').width() - el.parent().width();
        el.parent().find('.gradient').css('opacity', 1 - (el.scrollLeft() / maxScroll));
    });
};

Bingo.DatagridDragging = {};
Bingo.DatagridDragging.init = function () {
    $('#body-container:not(.backoffice) .datagrid > div:not(.gradient)').each(function () {
        $(this).dragTable();
    });
};

Bingo.AfterLoad.register(() => {
    Bingo.DatagridDragging.init();
});

$(window).resize(() => {
    Bingo.DatagridDragging.init();
});
